import { createFileRoute, Link } from '@tanstack/react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { AuthCard } from '@sentinel/ui';
import { EmailPrompt, type ResendStatus } from '../features/welcome/components/email-prompt';
import { useResendVerification } from '../features/welcome/use-resend-verification';

const searchSchema = z.object({
  email: z.string().email().optional().catch(undefined),
});

function getStatus(e: unknown): number | undefined {
  return (e as { status?: number } | null)?.status;
}

function WelcomePage() {
  const { t } = useTranslation('welcome');
  const { email } = Route.useSearch();
  const resend = useResendVerification();
  const [status, setStatus] = useState<ResendStatus>('idle');

  function onResend(address: string) {
    setStatus('idle');
    resend.mutate(
      { email: address },
      {
        onSuccess: () => setStatus('sent'),
        onError: (e) => {
          if (getStatus(e) === 429) {
            setStatus('rate_limited');
          } else {
            setStatus('error');
          }
        },
      },
    );
  }

  return (
    <AuthCard>
      <EmailPrompt
        {...(email ? { email } : {})}
        onResend={onResend}
        pending={resend.isPending}
        status={status}
      />
      <p style={{ textAlign: 'center' }}>
        <Link to="/login">{t('back_to_sign_in')}</Link>
      </p>
    </AuthCard>
  );
}

export const Route = createFileRoute('/welcome')({
  validateSearch: searchSchema,
  component: WelcomePage,
});
